import Http from '@/repository/Http';

function getStatus(onSuccess) {
  Http.get('/site/status', {}, onSuccess);
}

export default {
  getStatus,
};
